import { LogIn } from 'lucide-react'
import { Button } from './Button'

export { isSessionExpiredMessage, SESSION_EXPIRED_MESSAGE } from './sessionExpired'

export interface SessionExpiredActionProps {
  size?: 'sm' | 'md'
  className?: string
}

/**
 * Кнопка «Войти» при истёкшей сессии. Вход открывается в новой вкладке, чтобы не потерять введённое на текущей
 * странице: после входа достаточно вернуться и нажать «Повторить» (или сохранить ещё раз).
 */
export function SessionExpiredAction({ size = 'sm', className }: SessionExpiredActionProps) {
  return (
    <Button
      variant="secondary"
      size={size}
      className={className}
      icon={<LogIn className="h-3.5 w-3.5" />}
      title="Вход откроется в новой вкладке — введённое здесь не пропадёт. После входа вернитесь и повторите действие"
      onClick={() => window.open('/login', '_blank', 'noopener')}
    >
      Войти
    </Button>
  )
}

export default SessionExpiredAction
